module.exports = __webpack_public_path__ + "img/footer.a7de9542.jpg";